import { computed, observable } from 'mobx';
import { Product } from '@modules/products/models';
import { LoadingStatusState } from '@modules/core/models';
import { CancellablePromise } from 'mobx/lib/api/flow';

export class ProductsStore {
    @observable products: Product[] = [];
    @observable loadingStatusState = new LoadingStatusState();
    loadProducts: (...args: any[]) => CancellablePromise<void>;

    @computed get productsTabs() {
        return this.products.map((product: Product) => ({
            label: product.code,
            value: product.code
        }));
    }
}
